import * as auth from './types';
import state from './state';
import vueAuth from '@common/lib/auth';

export const ERRORS = 'ERRORS';
export const CURRENT_USER = 'CURRENT_USER';
export const IS_ENTERPRISE_USER = 'IS_ENTERPRISE_USER';
export const IS_JUDGEMENT_USER = 'IS_JUDGEMENT_USER';
export const IS_AUTHENTICATED = 'IS_AUTHENTICATED';
export const AUTH_REQ = 'AUTH_REQ';

const getters = {
  //[ERRORS]: (state: auth.State) => state.errors,
  [ERRORS](state) {
    return state.errors;
  },
  [CURRENT_USER](state) {
    //console.log('payload', vueAuth.getPayload(), state.user);
    return state.user;
  },
  [IS_ENTERPRISE_USER](state) {
    if (!state.user.roles) return false;
    return state.user.roles[0] === 'ROLE_USER_ENTERPRISE';
  },
  [IS_JUDGEMENT_USER](state) {
    if (!state.user.roles) return false;
    return state.user.roles[0] === 'ROLE_USER_JUDGEMENT';
  },
  [IS_AUTHENTICATED](state) {
    /*console.log(
      'hihihihihihihihihihi',
      state.isAuthenticated,
      vueAuth.isAuthenticated(),
    );*/
    const b = vueAuth.isAuthenticated();
    //return state.isAuthenticated && b;
    return vueAuth.isAuthenticated();
  },
  [AUTH_REQ](state) {
    return state.authReq;
  },
};

export default getters;
